import { useMemo } from "react";

import Typography from "@mui/material/Typography";

import { ingredientsObjectSelector } from "../../app/commonSelector";
import { useAppSelector } from "../../app/store/hooks";
import { getIngredientUnit, getIngredientValue, mesuringUnits } from "./ingredientUtils";

const measuringTbspUnitsData = (value: string, unit: string) => {
  const parsedValue = parseFloat(value);
  const ingredientUnit = getIngredientUnit(parsedValue * 2);
  const ingredientValue = getIngredientValue(parsedValue * 2);
  const isUnitTBSP = unit === mesuringUnits.TBSP;
  const measuringTbspUnits = isUnitTBSP ? `${parsedValue} ${mesuringUnits.LARGE_SPOON}` : `${ingredientValue} ${ingredientUnit}`;
  const pluralSuffix = ((isUnitTBSP && parsedValue > 1) || ingredientValue > 1) ? "s" : "";
  return { measuringTbspUnits, pluralSuffix };
}

const UnitDisplay = ({
  weighScaleAmount,
  ingredient,
}: {
  weighScaleAmount: any;
  ingredient: any;
}) => {
  const ingredients = useAppSelector(ingredientsObjectSelector);
  const [value, unit] = weighScaleAmount?.value?.split(" ");
  const weightBtnDisplay = `${value}${unit}`;
  const ingredientData = ingredients[ingredient?.id];
  const measuringUnit = useMemo(() => mesuringUnits.DEFAULT_UNIT_ARRAY.includes(unit), [unit]);
  const { measuringTbspUnits, pluralSuffix } = useMemo(() => measuringTbspUnitsData(value, unit), [value, unit]);

  if (!ingredients) return null;

  if (weighScaleAmount.displayBtn) {
    return (
      <Typography variant="ingredientText2mini">
        {weightBtnDisplay}
      </Typography>)
  };

  if (measuringUnit) {
    return (
      <Typography variant="ingredientText2mini">
        {measuringTbspUnits}
        {pluralSuffix}
      </Typography>
    );
  }

  if ((!value || value === "0") && ingredient?.tags.find((tag: string) => tag.toLowerCase() === "processed")) {
    return <div />;
  }

  if (!unit || !ingredientData?.defaultWeightUnit?.length || (ingredientData?.defaultWeightUnit === "piece" && !ingredientData?.conversion[0].unit?.length)) {
    return (
      <Typography
        sx={{ textAlign: "center", marginTop: "5px" }}
        variant="ingredientText2mini"
      >
        <span> </span>
        <span style={{ color: "#8F8F8F" }}>x</span>
        {value}
      </Typography>
    );
  }

  return (
    <Typography
      variant="ingredientText2mini"
      sx={{ textAlign: "center", marginTop: "5px" }}
    >
      {weighScaleAmount?.value}
    </Typography>
  );
};

export default UnitDisplay
